/* EMI banks, installments, submit/revert and EMI popups.
 *
 * Extracted verbatim from src/App.script.js. Behaviour is unchanged;
 * these methods run on the App instance exactly as before.
 */
import axios from "axios";

export default {
  methods: {


    getEmiDetailsByBank(emiData, bankId) {
      console.log(emiData); 
      // Check if the bank exists in the data
      if (emiData[bankId]) {
        const bankDetails = emiData[bankId];
        const tenureDescriptions = bankDetails.emiBankTenureDesc;

        // Map over the tenure descriptions to generate the required output
        const result = tenureDescriptions.map(item => ({
          baseAmount: item.baseAmount,
          tenure: item.tenure,
          monthlyInstallment: item.monthlyInstallment,
          totalAmountPayable: item.totalAmountPayable,
          emiCharge: item.emiCharge,
          interestRate: item.interestRate,
          tdrCharge: item.tdrCharge,
          isTdr: item.isTdr,
          isEmiCharge: item.isEmiCharge
        }));

        return result;
      } else {
        console.error("Bank ID not found in EMI data.");
        return [];
      }
    },
    transformEmiData(emiData) {
      console.log(emiData);
            const transformedData = [];

            Object.values(emiData.emi).forEach((bank) => {
                transformedData.push({
                    id: bank.emiBankID,
                    name: bank.emiBankName,
                    //bank_slug: bank.emiBankName.toLowerCase().replace(/\s+/g, '-'),
                });
            });
            console.log(transformedData);
            return transformedData;
        },
    closeInitialPopup() {
      this.emi_display_tab = false;
      this.emi_tab = true;
      this.emiPopUp = true;
      this.emiDisplayPopUp = false;
    },

    goNormalTransaction() {
      this.emi_display_tab = false;
      this.emi_tab = false;
      this.emiPopUp = false;
      this.emiDisplayPopUp = false;
      this.makeTransactionNonEMI();
      this.MerchantInfo(this.sp_orderid);
    },

    async fetchBanks() {
      try {
        // Replace 'your_api_endpoint' with the actual API endpoint to fetch the list of banks
        let bank_endpoint = this.base_url + "emi/banks";
        const response = await axios.get(bank_endpoint);
        // Assuming the response data is an array of banks
        this.banks = response.data;
      } catch (error) {
        console.error("Error fetching banks:", error);
      }
    },
    async fetchEMIBanks(sp_order_id) {
      try {
        // Replace 'your_installments_api_endpoint' with the actual API endpoint to fetch installment data
        const response = await axios.get(`${this.base_url}installments-all`, {
          params: {
            transaction_id: sp_order_id,
          },
        });

        // Assuming the response data is an array of installments
        this.merchantEMIBankList = response.data;
        console.log(this.merchantEMIBankList);
        this.banks = this.transformEmiData(response.data);

      } catch (error) {
        console.error("Error fetching installments:", error);
      }
    },

    onDisplayBankSelected(selectedBank) {
      this.selectedBankId = selectedBank.id;
      console.log("Selected Bank ID:", this.selectedBankId);
      //this.fetchInstallments(selectedBank.id, this.sp_orderid);
      // this.selectedBankInstallments = [
      //   { id: 1, tenure: 3, monthlyInstallment: 100 },
      //   { id: 2, tenure: 6, monthlyInstallment: 150 },
      //   { id: 3, tenure: 9, monthlyInstallment: 100 },
      //   { id: 4, tenure: 12, monthlyInstallment: 150 },
      //   { id: 5, tenure: 24, monthlyInstallment: 150 },
      //
      //   // Add more installments as needed
      // ];
    },

    onBankSelected(selectedBank) {
      this.selectedBankId = selectedBank.id;
      console.log("Selected Bank ID:", this.selectedBankId);
      this.selectedBankInstallments = this.getEmiDetailsByBank(this.merchantEMIBankList.emi, this.selectedBankId);
      console.log("Selected Bank Isnstallment");
      console.log(this.selectedBankInstallments);

      //this.fetchInstallments(selectedBank.id, this.sp_orderid);
     

    },

    async fetchInstallments(selectedBankId, transactionId) {
      try {
        // Replace 'your_installments_api_endpoint' with the actual API endpoint to fetch installment data
        const response = await axios.get(`${this.base_url}installments`, {
          params: {
            transaction_id: transactionId,
            bank_id: selectedBankId,
          },
        });

        // Assuming the response data is an array of installments
        this.selectedBankInstallments = response.data;
      } catch (error) {
        console.error("Error fetching installments:", error);
      }
    },

    handleTenureSelected({ tenure, installmentId }) {
      console.log(tenure);
      this.selectedTenure = tenure;
    },
    handleSubmitInstallments({ bankId, tenure }) {
      // Assuming you have the required data like tenure, transaction_id, etc.
      const tenure_id = tenure.tenure; /* selected tenure - number of month */
      const transactionId = this.sp_orderid; /* your sp_order_id value */

      // Data to be sent in the request body
      const requestData = {
        tenure: tenure.tenure,
        bank_id: bankId,
        transaction_id: transactionId,
      };

      // Make a POST request using axios
      axios
        .post(this.base_url + "emi/submit", requestData)
        .then((response) => {
          // Check if the response status is 200
          if (response.status === 200) {
            // If successful (status code 200), do one thing
            // You can access the response data using response.data
            this.handleSuccess(response.data);
            if (bankId != 2) {
              this.hidePaymentMethod("american-express");
            }
          } else {
            // If not successful, do another thing
            this.handleFailure(response.status);
          }
        })
        .catch((error) => {
          // Handle errors
          console.error("Error:", error);
          // Do something else on error
        });
    },

    handleSuccess(data) {
      // Handle the data if needed
      console.log("Response data:", data);
      this.closeEMIPopUp();
      this.show_emi_button = false;
      this.disableCardTab = false;
      this.disableMbankingTab = true;
      this.disableIBankingTab = true;
      this.disableLoginTab = true;
      this.disableProfileTab = true;
      this.isTransactionEMI = 1;
      this.show_cards(1);
      this.hidePaymentMethod("dbbl-two-nexus");
      this.hidePaymentMethod("dbbl-debit-visa");
      this.hidePaymentMethod("dbbl-debit-master");
      this.hidePaymentMethod("nexus-pay");
      this.hidePaymentMethod("tbl-visa");

      // Do something with the data
    },

    handleFailure(status) {
      // Handle failure
      console.error("Failed to submit. Status code:", status);
      // Do something else on failure
    },

    OTPReverse(id) {
      var previous_value = id;
      document.getElementById(previous_value).focus();
    },

    // Rintu - Check For Is EMI enable for Store??
    fetchStoreEMISettings(orderid) {
      const options = {
        method: "GET",
        url: this.base_url + "merchant-config/" + orderid,
        headers: {
          Authorization: "Bearer " + this.sp_token,
          "Content-Type": "application/json",
        },
      };
      axios
        .request(options)
        .then((response) => {
          // Store the response data in the global variable
          this.merchantConfigData = response.data;
          this.currencyCode = response.data.currency_info.currency; 
          this.amountBDT = parseFloat(response.data.currency_info.rate).toFixed(2);
          this.is_emi_active = response.data.merchant_info[0].is_emi;
          let payment_amount = parseInt(
            response.data.gateway_info.bank[0].request_amount
          );

          if (
            response.data.merchant_info &&
            response.data.merchant_info.length > 0 &&
            response.data.merchant_info[0].minimum_emi_amount != undefined &&
            response.data.merchant_info[0].minimum_emi_amount > 0
          ) {
            this.minimum_emi_amount = parseInt(
              response.data.merchant_info[0].minimum_emi_amount
            );
          }

          console.log(this.is_emi_active);
          console.log(this.minimum_emi_amount);

          console.log(payment_amount);

          if (this.is_emi_active && payment_amount >= this.minimum_emi_amount) {
            this.fetchEMIBanks(this.$route.query.order_id);
            this.showDisplayEMIPopUp();
          } else {
            this.MerchantInfo(this.sp_orderid);
          }
        })
        .catch((error) => {
          this.MerchantInfo(this.sp_orderid);
          console.log(error);
        });
    },

    CallEmiApi(bin) {
      var header_token = this.$route.query.token;
      var orderid = this.$route.query.order_id;
      var store_id = this.store_id;

      const options = {
        method: "POST",
        url: this.base_url + "emi-check",
        headers: { Authorization: "Bearer " + header_token },
        data: { bin, orderid, store_id },
      };

      axios
        .request(options)
        .then((response) => {
          if (response.data[0].sp_code == 200) {
            this.colWidth = 6;
            this.is_emi_visible = true;

            var setemi_options = [];
            var i;
            for (i = 0; i < response.data.length; i++) {
              setemi_options.push({
                id: i,
                option_val:
                  response.data[i].emi_month +
                  " months- " +
                  response.data[i].amount.toFixed(2) +
                  "/Month",
                select_val: response.data[i].emi_month + " months",
              });
            }
            this.emi_options = setemi_options;
          } else {
            this.is_emi_visible = false;
            this.colWidth = 12;
          }
        })
        .catch((error) => {
          this.is_emi_visible = false;
          this.colWidth = 12;
          console.log(error);
        });
    },

    showDisplayEMIPopUp() {
      this.emi_display_tab = true;
      this.emiDisplayPopUp = true;
      console.log(this.emi_tab);
      //this.show_cards('emi');
    },

    showEMIPopUp() {
      this.emi_tab = true;
      this.emiPopUp = true;
      this.show_cards("emi");
    },

    closeEMIPopUp() {
      this.emi_tab = false;
      this.emiPopUp = false;
      this.MerchantInfo(this.sp_orderid);
      this.show_cards(0);
      // this.disableCardTab = false;
      // this.disableMbankingTab = false;
      // this.disableIBankingTab = false;
      // this.disableLoginTab = false;
      // this.disableProfileTab = false;
    },
  },
};
